import React, { Component } from "react"
import { Mutation } from "react-apollo"
import REMOVE_DEVICE from "../../graphql/removeDevice.graphql"
import "./editDeviceModal.scss"

class EditDeviceModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dialogue: null,
      queuedForDeletion: [],
      devices: props.viewer.devices,
    }
  }

  toggleDeviceIcon = (device) => {
    const { type } = device

    return "fa " + (type === "desktop" ? "fa-desktop" : "fa-mobile-alt")
  }

  renderDeviceList = () => {
    if (this.state.devices.length < 1) {
      return <div id="no-devices">No Devices</div>
    }

    const deviceList = this.state.devices.map((device, idx) => {
      return (
        <div
          className="edit-device-device-card"
          data-cy="registered-device"
          key={idx}
        >
          <div className="edit-device-device-icon">
            <span className={this.toggleDeviceIcon(device) + " device-icon"} />
          </div>
          <div className="edit-device-device-title">
            <h3>{device.name}</h3>
          </div>
          <div className="edit-device-remove-button">
            <span
              title="remove device"
              className="fa fa-times"
              data-cy="remove-device"
              onClick={() => this.removeDevice(device.token)}
            />
          </div>
        </div>
      )
    })

    return <div className="edit-device-list">{deviceList}</div>
  }

  removeDevice = (token) => {
    const newDeviceList = this.state.devices.filter((device) => {
      return token !== device.token
    })

    const queuedForDeletion = this.state.queuedForDeletion.concat(token)

    this.setState({
      devices: newDeviceList,
      queuedForDeletion,
    })
  }

  onSaveClick = async () => {
    if (this.state.queuedForDeletion.length > 0) {
      await this.props.removeDevice({
        variables: {
          tokens: this.state.queuedForDeletion,
        },
      })
    }

    this.props.close()
  }

  render() {
    return (
      <div className="edit-device-container">
        <div className="edit-device-header">
          <h1>Edit Devices</h1>
        </div>

        <div className="edit-device-list-container">
          {this.renderDeviceList()}
        </div>

        <div className="edit-devices-buttons">
          <button
            id="edit-devices-save-button"
            data-cy="device-save-button"
            onClick={this.onSaveClick}
          >
            Save
          </button>
          <button id="edit-devices-cancel-button" onClick={this.props.close}>
            Cancel
          </button>
        </div>
      </div>
    )
  }
}

const EditDeviceModalWithData = (componentProps) => (
  <Mutation mutation={REMOVE_DEVICE}>
    {(removeDevice) => (
      <EditDeviceModal {...componentProps} removeDevice={removeDevice} />
    )}
  </Mutation>
)

export default EditDeviceModalWithData
